<template>
  <b-card
    class="card-tiny-line-stats"
    body-class="pb-50"
  >
    <div class="d-flex justify-content-between align-content-center">
      <h6>
        {{ $t('NPL Ratio') }}
      </h6>
      <feather-icon
        icon="RotateCwIcon"
        class="cursor-pointer"
        @click="fetchNplRatio"
      />
    </div>

    <h2 class="font-weight-bolder mb-1">
      {{ nplRatioValue }}
    </h2>

    <!-- chart -->
    <!-- <vue-apex-charts
      height="70"
      :options="statisticsOrder.chartOptions"
      :series="data.series"
    /> -->
    <Spinner :show="isLoadingNplRatio" />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { onMounted, ref } from '@vue/composition-api'
import { useActions } from 'vuex-composition-helpers'
import Spinner from '@/views/components/spinner/Spinner.vue'
import useToastAlert from '../../../composable/useToast'

export default {
  components: {
    BCard,
    Spinner,
  },
  setup() {
    const {
      getNplRatio,
    } = useActions({
      getNplRatio: 'dashboard/getNplRatio',
    })

    const { toastAlert } = useToastAlert()
    const nplRatioValue = ref(null)

    const isLoadingNplRatio = ref(false)

    const fetchNplRatio = async () => {
      try {
        isLoadingNplRatio.value = true
        const response = await getNplRatio()

        const { status, data } = response
        if (status === 200 && data) {
          nplRatioValue.value = data.percentage
        }
      } catch (err) {
        toastAlert(err)
      } finally {
        isLoadingNplRatio.value = false
      }
    }

    onMounted(async () => {
      await fetchNplRatio()
    })

    return {
      nplRatioValue,
      isLoadingNplRatio,
      fetchNplRatio,
    }
  },
}
</script>

<style scoped>
.card .card-header {
    padding: 0.5rem 0;
}
 /* .card-body {
    padding: 0.8rem;
} */
</style>
